import {createStore, applyMiddleware, combineReducers} from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from "redux-devtools-extension";

import stateForm from './redux/stateForm'
import animationForm from './redux/animationForm'
import stateLoader from './redux/loader'
import authorization from './redux/authorization'
import {derictory} from './redux/derictory'

export default function configureStore(initialState) {
  return createStore(
    combineReducers({
      stateForm,
      animationForm,
      stateLoader,
      authorization,
      derictory
    }),
    initialState,
    process.env.NODE_ENV === 'development' ? 
      composeWithDevTools(applyMiddleware(thunk)) :
      applyMiddleware(thunk)
  );
}